import Component from "./PuppyBowl2Card";
export default Component;
